// @flow
import React from 'react';
import styled from '@emotion/styled';

type OrganizationPlateProps = {
  nav: React$Node;
  content: React$Node;
}

export const OrganizationPlateTag = styled.div`
  display: grid;
  grid-template-columns: 232px 1fr;
  grid-template-areas: "secondaryNav content";
  height: calc(100vh - ${props => props.theme.SIZES.USER_FLOW.headerMdHeight});
`;

export const OrganizationPlate = ({ nav, content } :OrganizationPlateProps) => (
  <OrganizationPlateTag>
    { nav }
    { content }
  </OrganizationPlateTag>
);
